export default "/assets/images/mila-valentine-black-white.png?faa15ce0cdb43713d1cabc4c6196d4f9";